module.exports = __webpack_public_path__ + "assets/img/5.35ae7c6c.jpg";